import { useEffect, useState } from "react";
import { useDataEstimateContext } from "../../../../hooks/useModalContex";

interface IResetor {
  handleResetStreet: () => void;
  handleResetBuilding: () => void;
  handleResetComplex: () => void;
  handleResetBuildingComplex: () => void;
  handleResetTypesApartment: () => void;
  handleResetArea: () => void;
  resetData?: () => void;
}

const useReset = (
  isSecondarySwitcher: boolean,
  resetor: IResetor,
  selectedStreet: number | null,
  selectedComplex: number | null,
  selectedBuildingSecondary: number | null,
  selectedBuildingPrimary: number | null,
  selectedTypesApartment: number | null,
  areaInSqM: string | null | undefined
) => {
  const { onSetDataModal } = useDataEstimateContext();

  const resetValues = [
    "street",
    "building",
    "complex",
    "buildingComplex",
    "typesApartment",
    "area",
  ];

  type TResetValues = typeof resetValues;

  const [isBlockReset, setIsBlockReset] = useState(false);

  const handleIsReset = (value: boolean) => {
    setIsBlockReset(() => value);
  };

  useEffect(() => {
    onSetDataModal(null);
    handleResetDataChoice(resetValues);
  }, [isSecondarySwitcher]);

  const handleResetDataChoice = (resetValues: TResetValues) => {
    if (!isBlockReset) {
      if (isSecondarySwitcher) {
        resetValues.includes("street") && resetor.handleResetStreet();
        resetValues.includes("building") && resetor.handleResetBuilding();
        resetValues.includes("complex") && resetor.handleResetComplex();
      } else {
        resetValues.includes("street") && resetor.handleResetStreet();
        resetValues.includes("complex") && resetor.handleResetComplex();
        resetValues.includes("buildingComplex") &&
          resetor.handleResetBuildingComplex();
      }
      resetValues.includes("typesApartment") &&
        resetor.handleResetTypesApartment();
      resetValues.includes("area") && resetor.handleResetArea();
    }
  };

  useEffect(() => {
    if (selectedStreet || selectedComplex) {
      handleResetDataChoice([
        "building",
        "buildingComplex",
        "typesApartment",
        "area",
      ]);
      resetor.resetData && resetor.resetData();
    }
  }, [selectedStreet, selectedComplex]);

  useEffect(() => {
    if (selectedBuildingSecondary || selectedBuildingPrimary) {
      handleResetDataChoice(["typesApartment", "area"]);
      resetor.resetData && resetor.resetData();
    }
  }, [selectedBuildingSecondary, selectedBuildingPrimary]);

  useEffect(() => {
    if (selectedTypesApartment) {
      handleResetDataChoice(["area"]);
      resetor.resetData && resetor.resetData();
    }
  }, [selectedTypesApartment]);

  useEffect(() => {
    resetor.resetData && resetor.resetData();
  }, [areaInSqM]);

  const handleAllReset = () => {
    if (isSecondarySwitcher) {
      handleResetDataChoice(["street", "building", "area"]);
    } else {
      handleResetDataChoice([
        "complex",
        "buildingComplex",
        "typesApartment",
        "area",
      ]);
    }
    resetor.resetData && resetor.resetData();
  };

  return {
    onAllReset: handleAllReset,
    handleIsReset,
    onResetDataChoice: handleResetDataChoice,
  };
};

export default useReset;
